export const USER_TYPE = {
  storeOwner: 'store-owner',
  saleManager: 'sale-manager',
};
